import { servicePath, type ServiceRoute } from '@vnetwork/margarita-shell/service-route';
import { aesPaths } from './paths';

// Plain data + a lazy loader: do not import the console here (it would join the entry chunk).
export const servicesRoutes: ServiceRoute[] = [
  { path: servicePath(aesPaths.base, '*'), load: () => import('./index').then((m) => ({ default: m.AesPage })) },
];
